import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
export const TooltipWrapper = ({ text = null, position = 'bottom', child }) => {
	const LightTooltip = styled(({ className, ...props }) => (
		<Tooltip
			{...props}
			classes={{ popper: className }}
		/>
	))(({ theme }) => ({
		[`& .${tooltipClasses.tooltip}`]: {
			backgroundColor: theme.palette.common.white,
			color: 'rgba(0, 0, 0, 0.87)',
			boxShadow: theme.shadows[1],
			fontSize: 11,
		},
	}));
	return (
		<>
			{text ? (
				<LightTooltip
					title={text}
					placement={position}>
					{child}
				</LightTooltip>
			) : null}
		</>
	);
};
